class DottedBorderElement extends HTMLElement {
  connectedCallback() {
    this._canvas = this.appendChild(document.createElement("canvas"));

    this._ro = new ResizeObserver(() => this._render());
    this._ro.observe(this);
    this._render();
  }

  disconnectedCallback() {
    this._ro?.disconnect();
  }

  _render() {
    const dpi = devicePixelRatio;
    const w = this.clientWidth;
    if (!w) return;

    const canvas = this._canvas;
    canvas.width = Math.round(w * dpi);
    canvas.height = Math.round(2 * dpi);

    const c = canvas.getContext("2d");
    c.scale(dpi, dpi);
    c.fillStyle = getComputedStyle(this).color;

    const r = 1;
    let step = 8;
    for (let x = r; x < w; x += step) {
      c.beginPath();
      c.arc(x, r, r, 0, Math.PI * 2);
      c.fill();
      step *= 1.05;
    }
  }
}

customElements.define("dotted-border", DottedBorderElement);
